import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Button from "../common/Button";
import CardWrap from "../layouts/CardWrap";
import Input from "../common/Input";
import SelectBox from "../common/Select";
import CheckBox from "../common/Checkbox";
import useSWR from "swr";
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import {toast} from "react-toastify";
import Pagination from "../Pagination";
/** @type {string} */
import IcClose from "../../assets/icons/ic-close.svg";
import {useStore} from "../../app/store";

const ProductConnectModal = ({modalDepth}) => {
    const [searchType, setSearchType] = useState("");
    const [searchString, setSearchString] = useState("");
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState("");
    const [offset, setOffset] = useState(1);
    const [limit, setLimit] = useState(5);
    const [onlyLinked, setOnlyLinked] = useState(false);
    const [queryString, setQueryString] = useState("");
    const [productLinkByPage, setProductLinkByPage] = useState(undefined);
    const [products, setProducts] = useState([]);
    const [productCount, setProductCount] = useState(0);
    const {appEditorStore, confirmStore} = useStore();
    const makeQueryString = () => {
        const queryStringList = [`offset=${offset - 1}`, `limit=${limit}`];
        if (searchType && searchType.length > 0) queryStringList.push(`searchType=${searchType}`);
        if (searchString && searchString.length > 0) queryStringList.push(`searchString=${searchString}`);
        if (category && category > 0) queryStringList.push(`category=${category}`);
        if (onlyLinked) queryStringList.push(`linked=${onlyLinked}`);
        setQueryString(queryStringList.join('&'));
    }
    let {
        data: productsInfo,
        error: errorProductInfo,
        isLoading: isLoadingProductInfo,
        mutate: mutateProductInfo
    } = useSWR(`/product${queryString.length > 0 ? '?' + queryString : ''}`);

    let {
        data: productLinkByPageInfo,
        error: errorProductLinkByPage,
        isLoading: isLoadingProductLinkByPage,
        mutate: mutateProductLinkByPage
    } = useSWR(appEditorStore.pageInfo.id ? `/product/linkedByPage?pageId=${appEditorStore.pageInfo.id}` : null);

    let {
        data: categoryInfo,
        isLoading: isLoadingCategoryInfo,
    } = useSWR('/product/category');

    useEffect(() => {
        if (!isLoadingProductInfo && productsInfo && productsInfo.data) {
            setProducts(productsInfo.data.products);
            setProductCount(productsInfo.data.productCount);
        }
    }, [productsInfo]);
    useEffect(() => {
        if (!isLoadingProductLinkByPage && productLinkByPageInfo && productLinkByPageInfo.data) {
            setProductLinkByPage(productLinkByPageInfo.data.productLinkByPage);
        }
    }, [productLinkByPageInfo]);

    useEffect(() => {
        if (!isLoadingCategoryInfo && categoryInfo && categoryInfo.data) {
            const categories = categoryInfo.data.categories.map((category) => {
                return {label: category.categoryName, value: category.categoryNo};
            });
            setCategories(categories);
        }
    }, [categoryInfo]);

    useEffect(() => {
        makeQueryString();
    }, [offset]);

    const prdDescSearch = [
        {value: "productNo", label: "상품번호"},
        {value: "productName", label: "상품명"},
        {value: "pageName", label: "상세페이지명"},
    ];


    // 검색 버튼
    const onClickSearch = async () => {
        if (searchType.length === 0 && searchString.length === 0 && category.length === 0) {
            return toast("검색 조건을 설정하신 후 검색하실 수 있습니다.");
        }
        if (searchType.length > 0 && searchString.length === 0) {
            return toast("검색어를 입력하세요.");
        }
        if (searchType.length === 0 && searchString.length > 0) {
            return toast("검색분류를 선택하세요.")
        }
        setOffset(1);
        makeQueryString();
        const result = await mutateProductInfo();
        productsInfo = result.data;
    };


    // 초기화 버튼
    const onClickReset = async () => {
        setSearchType("");
        setSearchString("");
        setCategory("");
        setOnlyLinked(false);
        setOffset(1);
        setLimit(5);
        setQueryString("");
    };

    const onClickDisconnect = async (productNo) => {
        confirmStore.openConfirm({
            confirmText: "끊기",
            text: "연결을 끊으시겠습니까?\n연결을 끊어도 사이트의 상세 페이지는\n기존 화면으로 유지됩니다.",
            confirmFunc: async () => {
                try {
                    const response = await axios.delete(`/product/disconnect`, {data: {productNo}});
                    const disconnectedPageId = response.data.data.pageId;
                    toast("연결이 해제되었습니다.", {autoClose: 1000});
                    await mutateProductLinkByPage();
                    await mutateProductInfo();
                    if (appEditorStore.pageInfo.id === disconnectedPageId) {
                        appEditorStore.setPageProductNo(undefined);
                        await appEditorStore.setPageStatus("CHECK_COMPLETE");
                    }
                } catch (e) {
                    console.log(e)
                } finally {
                    confirmStore.clear();
                }
            },
        });
    }

    const onClickConnect = async (productNo, productName) => {
        try {
            if (!appEditorStore.pageInfo.id) {
                toast("페이지를 저장 후에 이용해 주세요.");
                return;
            }
            if (
                appEditorStore.pageInfo.status === "REQUEST_RE_MODIFICATION" ||
                appEditorStore.pageInfo.status === "REQUEST_INSPECT" ||
                appEditorStore.pageInfo.status === "WORKING"
            ) {
                toast("확인 완료된 페이지만 이용가능 합니다.");
                return;
            }
            confirmStore.openConfirm({
                confirmText: "연결",
                text: `[${productName}]\n상품에 연결하시겠습니까?`,
                confirmFunc: async () => {
                    try {
                        const response = await axios.post(`/product/connect`, {
                            pageId: appEditorStore.pageInfo.id,
                            productNo: productNo
                        });
                        confirmStore.clear();
                        toast("연결되었습니다.");
                        await mutateProductLinkByPage();
                        await mutateProductInfo();
                        appEditorStore.setPageProductNo(response.data.data.productLinkByPage.productNo);
                        await appEditorStore.setPageStatus("CONNECTED");
                    } catch (e) {
                        if (e.code === 'ALREADY_EXIST_PRODUCT_LINK') {
                            confirmStore.openConfirm({
                                confirmText: "연결",
                                text: `기존 상품 [${productLinkByPage.productName}]과의\n연결을 끊고해당상품\n[${productName}]에 연결하시겠습니까?`,
                                confirmFunc: async () => {
                                    try {
                                        const res = await axios.post(`/product/connect`, {
                                            pageId: appEditorStore.pageInfo.id,
                                            productNo: productNo,
                                            force: true
                                        });
                                        toast("연결되었습니다.");
                                        await mutateProductLinkByPage();
                                        await mutateProductInfo();
                                        appEditorStore.setPageProductNo(res.data.data.productLinkByPage.productNo);
                                        await appEditorStore.setPageStatus("CONNECTED");
                                    } catch (e) {
                                        console.log(e)
                                    } finally {
                                        confirmStore.clear();
                                    }
                                },
                            });
                        } else {
                            confirmStore.clear();
                        }
                    }
                },
            });
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <ModalBody id="ProductConnect">
            <ProductConnectModalWrap>
                <CustomCardWrap>
                    <div className="table-grid-wrap">
                        <div className="row">
                            <div className="name">검색분류</div>
                            <div className={"wrap"}>
                                <div className="select-box">
                                    <SelectBox
                                        option={prdDescSearch}
                                        size={"xs"}
                                        classNamePrefix="선택"
                                        placeholder={"선택"}
                                        isSearchable={false}
                                        onChange={(e) => setSearchType(e.value)}
                                        value={prdDescSearch.filter((option) => option.value === searchType)}
                                    />
                                </div>
                                <div className="input-box">
                                    <CustomInput
                                        onChange={(e) => {
                                            setSearchString(e.target.value);
                                        }}
                                        value={searchString}
                                        placeholder={"검색어를 입력하세요."}
                                        id={"searchText"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="table-grid-wrap prd-depth">
                        <div className="row">
                            <div className="name">상품 분류</div>
                            <div className={"wrap"}>
                                <div className="select-box">
                                    <SelectBox
                                        option={categories}
                                        size={"xs"}
                                        classNamePrefix="선택"
                                        placeholder={"선택"}
                                        onChange={(e) => setCategory(e.value)}
                                        value={categories.filter((option) => option.value === category)}
                                    />
                                </div>
                                <div className="input-box">
                                    <CheckBox
                                        id={'prd_connect_chk'}
                                        onChange={(e) =>
                                            e.target.checked ? setOnlyLinked(true) : setOnlyLinked(false)
                                        }
                                        checked={onlyLinked}
                                    />
                                    <label htmlFor={'prd_connect_chk'}>
                                        연결된 항목만 검색
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SearchBtnWrap>
                        <Button
                            type={"outline"}
                            size={"m"}
                            text={"초기화"}
                            onClickFunc={onClickReset}
                        />
                        <Button
                            type={"fill"}
                            size={"m"}
                            text={"검색"}
                            onClickFunc={onClickSearch}
                        />
                    </SearchBtnWrap>
                </CustomCardWrap>

                <CardWithHeaderWrap>
                    <div className="box-header">
                        <h2>연결된 상품</h2>
                    </div>
                    <div className="box-body">
                        <span
                            className="table-total">{productLinkByPage ? '총 1개' : '총 0개'}</span>
                        <ProductTable>
                            <thead>
                            <tr>
                                <th>No</th>
                                <th>상품번호</th>
                                <th>이미지</th>
                                <th>상품명</th>
                                <th>상세 페이지</th>
                                <th>연결 설정</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                productLinkByPage ?
                                    <tr>
                                        <td>{productLinkByPage.productNo}</td>
                                        <td>{productLinkByPage.productCode}</td>
                                        <td>
                                            <img
                                                src={productLinkByPage.image ? productLinkByPage.image : IcClose}
                                                alt="dummy img"
                                            />
                                        </td>
                                        <td>
                                            {productLinkByPage.productName}
                                        </td>
                                        <td>{productLinkByPage.pageName}</td>
                                        <td>
                                            <button className="connect connected" onClick={() => {
                                                onClickDisconnect(productLinkByPage.productNo);
                                            }}>
                                                연결 끊기
                                            </button>
                                        </td>
                                    </tr>
                                    :
                                    <tr className={'no-data'}>
                                        <td colSpan={6}>현재 연결된 상품이 없습니다.</td>
                                    </tr>
                            }
                            </tbody>


                        </ProductTable>
                    </div>
                </CardWithHeaderWrap>

                <CardWithHeaderWrap>
                    <div className="box-header">
                        <h2>상품 목록</h2>
                    </div>
                    <div className="box-body">
                        <span className="table-total">{`총 ${productCount}개`}</span>
                        <ProductTable>
                            <thead>
                            <tr>
                                <th>No</th>
                                <th>상품번호</th>
                                <th>이미지</th>
                                <th>상품명</th>
                                <th>상세 페이지</th>
                                <th>연결 설정</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                products && products.length > 0 ?
                                    products.map(product => (
                                        <tr key={product.productCode}>
                                            <td>{product.productNo}</td>
                                            <td>{product.productCode}</td>
                                            <td>
                                                <img
                                                    src={product.image ? product.image : IcClose}
                                                    alt="dummy img"
                                                />
                                            </td>
                                            <td>
                                                {product.productName}
                                            </td>
                                            <td>
                                                {
                                                    product.pageName !== '-' ?
                                                        product.pageName
                                                        : '-'
                                                }
                                            </td>
                                            <td>
                                                {
                                                    product.pageName === '-' ?
                                                        <button className="connect" onClick={() => {
                                                            onClickConnect(product.productNo, product.productName);
                                                        }}>
                                                            연결
                                                        </button>
                                                        : <button className="connect connected" onClick={() => {
                                                            onClickDisconnect(product.productNo);
                                                        }}>
                                                            연결 끊기
                                                        </button>
                                                }
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <tr className={'no-data'}>
                                        <td colSpan={6}>현재 상품 목록이 없습니다.</td>
                                    </tr>
                            }
                            </tbody>

                        </ProductTable>
                        {
                            products && products.length > 0 &&
                            <div className={"products-pagination"}>
                                <Pagination
                                    totalItems={productCount}
                                    itemCountPerPage={5}
                                    pageCount={10}
                                    currentPage={offset}
                                    setPageIndex={setOffset}
                                />
                            </div>
                        }
                    </div>
                </CardWithHeaderWrap>
            </ProductConnectModalWrap>
        </ModalBody>
    );
};
const ProductConnectModalWrap = styled.div``
const ProductTable = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    tbody {
        tr {
            border-bottom: 1px solid var(--line-table-section-line, #eee);
        }

        .no-data {
            height: 150px;

            td {
                text-align: center;
                padding: 0px;
                color: rgb(176, 176, 176);
                font-size: 12px;
                font-weight: 400;
                letter-spacing: -0.12px;
            }
        }
    }

    th,
    td {
        text-align: center;
        vertical-align: middle;
        padding: 0 16px;
    }

    th {
        height: 40px;
        background: var(--disabled-bg-no-color, #fafafa);

        color: var(--txt-table-label, #555);
        text-align: center;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 138.462% */
        letter-spacing: -0.13px;

        &:nth-child(1) {
            width: 60px;
        }

        &:nth-child(1) {
            width: 80px;
        }

        &:nth-child(3) {
            width: 120px;
        }
    }

    td {
        padding: 8px 0;
        color: var(--Gray-1000_-262626, #262626);
        text-align: center;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 138.462% */
        letter-spacing: -0.13px;

        img {
            width: 80px;
        }

        &:nth-child(2) {
            width: 120px;
        }

        button.connect {
            width: 72px;
            height: 32px;

            overflow: hidden;
            color: var(--White_-FFFFFF, #fff);
            text-overflow: ellipsis;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.12px;

            border-radius: 3px;
            background: var(--Gray-1000_-262626, #262626);

            &.connected {
                background: #BDBDBD;
            }
        }
    }
`;

const CardWithHeaderWrap = styled.div`
    margin-top: 24px;
    border-radius: 10px;
    background: var(--White_-FFFFFF, #fff);
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.05);

    div.box-body {
        padding-top: 32px;
        padding-left: 32px;
        padding-right: 32px;
        padding-bottom: 16px;

        .products-pagination {
            margin-top: 16px;
        }

        span.table-total {
            margin-bottom: 16px;
            display: block;
            color: var(--description-txt, #949494);
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.12px;
        }
    }

    div.box-header {
        display: flex;
        align-items: center;
        height: 48px;
        padding: 0 32px;
        background: var(--Gray-100_-F5F5F5, #f5f5f5);

        h2 {
            color: var(--Gray-1000_-262626, #262626);
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px; /* 150% */
            letter-spacing: -0.16px;
        }
    }
`;

const CustomInput = styled(Input)`
    input {
        height: 32px;
    }
`;

const SearchBtnWrap = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
`;

const CustomCardWrap = styled(CardWrap)`
    min-width: unset;

    .table-grid-wrap {
        .row {
            .wrap {
                display: flex;
                padding: 0 16px;
                flex: 1;

                .select-box {
                    flex: 1;
                }

                .input-box {
                    width: 100%;
                    margin-left: 4px;

                    input {
                        outline: none;
                    }
                }
            }
        }

        &.prd-depth {
            .wrap {
                .select-box {
                    .react-select__control {
                        width: 220px;
                    }

                    .react-select__menu {
                        width: 220px;
                    }
                }

                .input-box {
                    margin-left: 16px;
                    display: flex;
                    align-items: center;

                    > label {
                        margin: 0 0 0 4px;
                        color: #262626;
                        font-size: 13px;
                        font-weight: 400;
                        letter-spacing: -0.13px;
                    }
                }
            }
        }


    }
`;

const ModalBody = styled.div`
    background-color: #f6f6f6;
    padding: 32px;
    max-height: calc(90vh - 48px);
    overflow: auto;
`;

const ModalHeader = styled.div`
    background: var(--Gray-1000_-262626, #262626);
    height: 48px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
        color: var(--White_-FFFFFF, #fff);
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 150% */
        letter-spacing: -0.16px;
    }

    svg {
        cursor: pointer;
    }
`;

const ModalContainer = styled.article`
    box-sizing: content-box;
    width: 1000px;
    margin: 0 auto;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(98, 120, 233, 0.1);
    border-radius: 10px;
    max-height: 90vh;
`;

const ProductConnectWrap = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

`;

const TableDisplay = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const Dimmer = styled.div`
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
`;
export default ProductConnectModal;
